import React from "react";

interface MasjidHeaderProps {
  masjidName: string;
}

export default function MasjidHeader({ masjidName }: MasjidHeaderProps) {
  return (
    <header className="masjid-header">
      <h1>{masjidName}</h1>
    </header>
  );
}
